import { Grid, Typography } from "@mui/material";
import MainTitle from "../muiHome/mainTitle";

const academic_programs_and_events=()=>{
return (
<Grid container spacing={2}>
<Grid item xs={12}>
    <MainTitle title="Academic Programs and Events" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Facility Development Program" />
    </Grid>
 
    </Grid>

)
}
export default academic_programs_and_events;